import React, {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';
import {useTrackingContext} from '../../../hooks/useTrackingContext';

import {undef} from '../../../utils/undef';
import {triggerDestinationSummaryClickEdapEvent} from '../../../utils/edap';
import {showDestinationIcon} from '../../../utils/destination';

import {SearchIcon} from '../../SearchIcon/SearchIcon';

const classNamespace = 'search-form';
const fieldClassName = `${classNamespace}__field`;
const inputFieldClassName = `${classNamespace}__input-field`;
const summaryFieldClassName = `${classNamespace}__summary-field`;
const summaryInputFieldClassName = `${classNamespace}__summary-input-field`;
const destinationSummaryInputFieldClassName = `${classNamespace}__destination-summary-input-field`;
const destinationSummaryInputFieldNoButtonClassName = `${classNamespace}__destination-summary-input-field-no-button`;
const destinationSummaryInputFieldContrastClassName = `${classNamespace}__destination-summary-input-field-contrast`;
const destinationSummaryInputFieldContrastNoButtonClassName = `${destinationSummaryInputFieldContrastClassName}-no-button`;

// eslint-disable-next-line complexity
function useComponent() {
    const {
        edapOptions,
        formOptions,
        detailsModalActions: {
            setIsOpen: setIsDetailsModalOpen
        },
        destinationOptions,
        destinationOptions: {
            iconName
        },
        destinationTranslations: {
            placeholderMessage,
            whereLabel
        },
        latestDestinationValues: {
            destination: search
        },
        destinationSummaryEvents: {
            onClick: onDestinationSummaryClick
        }
    } = useSearchFormContext();

    const trackingContext = useTrackingContext();

    const {isColourContrastAndLabels, isCollapsedSearchformCTA} = formOptions;

    let chooseClassNames = classNames(fieldClassName, inputFieldClassName, summaryFieldClassName, summaryInputFieldClassName, destinationSummaryInputFieldClassName);

    if (isColourContrastAndLabels && isCollapsedSearchformCTA) {
        chooseClassNames = classNames(fieldClassName, inputFieldClassName, summaryFieldClassName, summaryInputFieldClassName, destinationSummaryInputFieldClassName, destinationSummaryInputFieldContrastClassName, destinationSummaryInputFieldContrastNoButtonClassName);
    } else if (isColourContrastAndLabels) {
        chooseClassNames = classNames(fieldClassName, inputFieldClassName, summaryFieldClassName, summaryInputFieldClassName, destinationSummaryInputFieldClassName, destinationSummaryInputFieldContrastClassName);
    } else if (isCollapsedSearchformCTA) {
        chooseClassNames = classNames(fieldClassName, inputFieldClassName, summaryFieldClassName, summaryInputFieldClassName, destinationSummaryInputFieldClassName, destinationSummaryInputFieldNoButtonClassName);
    }

    const className = chooseClassNames;

    const id = 'search-destination-summary';

    const inputClassName = undef;

    const type = 'text';

    const label = search ? whereLabel : placeholderMessage;
    const srOnlyLabel = false;

    const value = search || '';

    const readOnly = true;
    const isReadOnly = (isCollapsedSearchformCTA) ? true : undef;

    const inverse = undef;
    const searchIcon = 'search';

    const icon = showDestinationIcon(formOptions, destinationOptions) && (
        (isCollapsedSearchformCTA) ?
            <SearchIcon name={searchIcon}/> :
            <SearchIcon name={iconName}/>
    ) || null;

    const leftContent = icon;
    const rightContent = undef;
    const contentClickable = false;

    const errorMsg = undef;
    const helpText = undef;

    const autoComplete = 'off';
    const autoCapitalize = 'off';
    const autoCorrect = 'off';
    const spellCheck = false;

    const ariaAutoComplete = 'both';

    const handleChange = undef;

    function handleClick(...args) {
        triggerDestinationSummaryClickEdapEvent(trackingContext, edapOptions);

        setIsDetailsModalOpen(true);

        onDestinationSummaryClick(...args);
    }

    const handleKeyPress = undef;

    const result = {
        className,
        id,
        inputClassName,
        type,
        label,
        srOnlyLabel,
        value,
        readOnly,
        isReadOnly,
        inverse,
        leftContent,
        rightContent,
        contentClickable,
        errorMsg,
        helpText,
        autoComplete,
        autoCapitalize,
        autoCorrect,
        spellCheck,
        ariaAutoComplete,
        onChange: handleChange,
        onClick: handleClick,
        onKeyPress: handleKeyPress
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
